import { ref } from '@vue/composition-api'
import axios from 'crypto-fetch/axios'
import { prefixLink } from '@ms/config/app'
import { isApp } from 'wap/hybrid/device'
import { tryAppLoadBookingCode } from 'wap/hybrid'

/**
 * Add to Betslip 增加跟投次数
 * @param {String}  bookingCode
 * @return {[type]} [description]
 */
const addToBetslip = async (bookingCode = '') => {
  return axios.post(`/orders/euro-code/add-followed-time?shareCode=${bookingCode}`)
}

export default function useAddToBetslip() {
  const buttonLoading = ref(false)

  const fetchAddToBetslip = async (code, channel) => {
    buttonLoading.value = true
    try {
      await addToBetslip(code)
    } catch (error) {
      console.error(error)
    }

    if (isApp()) {
      const jumpUrl = 'msport://sport_list?SPORT=Soccer&SPORT_ID=sr:sport:1'
      tryAppLoadBookingCode(code, jumpUrl)
    } else {
      const targetUrl = prefixLink('/sports/list?open=betslip&rebet=success')
      location.href = channel ? `${targetUrl}&from=${channel}` : targetUrl
    }
    buttonLoading.value = false
  }

  return {
    addToBetslip,
    buttonLoading,
    fetchAddToBetslip
  }
}
